import PropTypes from 'prop-types';
import React from 'react';
import TextField from 'material-ui/TextField';

import GenericFormItem from '../GenericFormItem';

const FormTextField = function FormTextField(props) {
  const {
    name,
    val,
    label,
    edit,
    onChange,
    disabled,
  } = props;
  let value = val;
  if (edit === true) {
    value = (
      <TextField
        name={label}
        defaultValue={val}
        fullWidth
        disabled={disabled}
        onChange={(evt, changeVal) => onChange(name, changeVal)}
      />
    );
  }
  return (
    <GenericFormItem label={label}>
      {value}
    </GenericFormItem>
  );
};

FormTextField.propTypes = {
  name: PropTypes.string.isRequired,
  val: PropTypes.string,
  label: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  edit: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

FormTextField.defaultProps = {
  onChange: () => {},
};

export default FormTextField;



// WEBPACK FOOTER //
// ./src/components/FormConfigs/TextField.js